/**
 * CornerMarks — four small engineering-blueprint crosshair marks at the
 * corners of a section, with a tiny revision code in the bottom-right.
 * Wrap an element with position:relative; add <CornerMarks code="SEC—01.HERO" />
 * as its last child.
 */
const Corner = ({ pos, accent }) => (
  <span
    aria-hidden
    className="absolute w-4 h-4 pointer-events-none"
    style={{
      ...pos,
      borderColor: "var(--border-strong)",
    }}
  >
    <span
      className="absolute"
      style={{
        width: "100%",
        height: 1,
        top: pos.top !== undefined ? 0 : "100%",
        background: accent,
        opacity: 0.55,
      }}
    />
    <span
      className="absolute"
      style={{
        width: 1,
        height: "100%",
        left: pos.left !== undefined ? 0 : "100%",
        background: accent,
        opacity: 0.55,
      }}
    />
  </span>
);

const CornerMarks = ({ code, accent = "var(--accent-blue)" }) => (
  <>
    <Corner pos={{ top: 10, left: 10 }} accent={accent} />
    <Corner pos={{ top: 10, right: 10 }} accent={accent} />
    <Corner pos={{ bottom: 10, left: 10 }} accent={accent} />
    <Corner pos={{ bottom: 10, right: 10 }} accent={accent} />
    {code && (
      <span
        aria-hidden
        className="absolute bottom-3 right-7 md:right-24 font-mono-spec text-[9px] tracking-[0.3em] uppercase pointer-events-none"
        style={{ color: "var(--text-faint)", opacity: 0.7 }}
      >
        {code}
      </span>
    )}
  </>
);

export default CornerMarks;
